//import { Icon } from "element-ui";
import { Message, MessageBox } from "element-ui";
export const downloadIamge = function (imgsrc, name) {
  //下载图片地址和图片名
  var image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

    var a = document.createElement("a"); // 生成一个a元素
    var event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgsrc;
};
//返回文件大小的函数
export const rFileSize = function (size) {
  return size / 1024 / 1024;
};
export const myFixed = function (num, digit) {
  if (Object.is(parseFloat(Number(num)), NaN)) {
    return console.log(`传入的值：${num}不是一个数字`);
  }
  num = parseFloat(num);
  return (
    Math.round((num + Number.EPSILON) * Math.pow(10, digit)) /
    Math.pow(10, digit)
  ).toFixed(digit);
};

//返回时间戳
/**
 * 格式化日期
 * @param {"eng"|"slash"|"count"|"cn"|"count_dd"|"yyyy-mm-dd"} key eng-"yy-mm-dd hms" slash-"yy/mm/dd hms" count-"yymmdd hms" cn-"yy年mm月dd日hms" count_dd-"yymmdd"
 * @param {Date} date 需要格式化的时间
 * @returns eng-"yy-mm-dd hms" slash-"yy/mm/dd hms" count-"yymmdd hms" cn-"yy年mm月dd日hms" count_dd-"yymmdd"
 */
export const timeFun = function (key, dates = new Date()) {
  let date = dates;
  if (String(date).indexOf("年") > -1 && String(date).indexOf("月") > -1) {
    date = dates.replace("年", "-")
      .replace("月", "-")
      .replace("日", "");
  }
  //获取当前时间并打印
  let yy = new Date(date).getFullYear();
  // let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
  var month = new Date(date).getMonth() + 1;
  let mm = (month < 10 ? "0" : "") + month;
  let dd =
    new Date(date).getDate() < 10
      ? "0" + new Date(date).getDate()
      : new Date(date).getDate();
  let hh =
    new Date(date).getHours() < 10
      ? "0" + new Date(date).getHours()
      : new Date(date).getHours();
  let mf =
    new Date(date).getMinutes() < 10
      ? "0" + new Date(date).getMinutes()
      : new Date(date).getMinutes();
  let ss =
    new Date(date).getSeconds() < 10
      ? "0" + new Date(date).getSeconds()
      : new Date(date).getSeconds();
  // const gettime = ;
  // return gettime
  switch (key) {
    case "eng":
      return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
    case "slash":
      return yy + "/" + mm + "/" + dd + " " + hh + ":" + mf + ":" + ss;
    case "count":
      return yy + mm + dd + hh + mf + ss;
    case "cn":
      return (
        yy + "年" + mm + "月" + dd + "日 " + hh + "时" + mf + "分" + ss + "秒"
      );
    case "cnshort":
      return yy + "年" + mm + "月" + dd + "日 ";
    case "count_dd":
      return yy + mm + dd;
    case "yyyy-mm-dd":
    case "":
      console.log("public---------", yy + "-" + mm + "-" + dd);
      return yy + "-" + mm + "-" + dd
  }
};

/**
 * @param {Number} dayNum 需要计算的天数
 * @param {Date} date 需要计算的时间
 * @returns 返回dayNum天后的日期    yy-mm-dd
 */
export const GetDateTime = function (dayNum, date = new Date()) {
  try {
    var dateDay = date;
    dateDay.setDate(dateDay.getDate() + dayNum); //获取dayNum天后的日期
    var y = dateDay.getFullYear();
    var m =
      dateDay.getMonth() + 1 < 10
        ? "0" + (dateDay.getMonth() + 1)
        : dateDay.getMonth() + 1; //获取当前月份的日期，不足10补0
    var d = dateDay.getDate() < 10 ? "0" + dateDay.getDate() : dateDay.getDate(); //获取当前几号，不足10补0
    console.log("计算出的日期----", y);
    console.log("计算出的日期----", m);
    console.log("计算出的日期----", d);
    return y + "-" + m + "-" + d;
  } catch (e) {
    console.log("出错", e);
  }
};

/* //搜索商品库
export const baGoodsQuery = async function(value) {
    const res = await baseGoodsQuery(value);
    console.log(res);
    if (res.data.return_code == "SUCCESS" && res.data.result_code == "SUCCESS") {

    }
} */

//删除选出的值 传两个数组 arr1存放 arr2需要删除的值 arr2是需要修改的数组 key存放arr2某一项的标识 save = true 返回不相同的 save =false 返回相同的
export const deleteTabRepeat = function (arr11, arr22, key, save = true) {
  console.log(arr11);
  console.log(arr22);
  /* console.log(key);
  console.log(save); */
  const all_arr = [];
  const mo_arr = [];
  const arr1 = Array.from(arr11);
  const arr2 = Array.from(arr22);
  for (let i = 0; i < arr2.length; i++) {
    all_arr.push(arr2[i]);
  }
  if (save) {
    for (let j = 0; j < all_arr.length; j++) {
      if (key) {
        if (arr1.indexOf(all_arr[j][key]) < 0) {
          mo_arr.push(all_arr[j]);
        }
      } else {
        if (arr1.indexOf(all_arr[j]) < 0) {
          mo_arr.push(all_arr[j]);
        }
      }
    }
  } else {
    for (let j = 0; j < all_arr.length; j++) {
      if (key) {
        if (arr1.indexOf(all_arr[j][key]) >= 0) {
          mo_arr.push(all_arr[j]);
        }
      } else {
        if (arr1.indexOf(all_arr[j]) < 0) {
          mo_arr.push(all_arr[j]);
        }
      }
    }
  }

  return mo_arr;
};

export const getEnvironment = function () {
  let userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.match(/Alipay/i) === "alipay") {
    //alert("支付宝浏览器");
    return "alipay";
  } else if (userAgent.match(/MicroMessenger/i) === "micromessenger") {
    // alert("微信浏览器");
    return "wechat";
  } else {
    return "h5";
  }
};
/* export const getEnvironment = function() {
  this.data = window.navigator.userAgent.toLowerCase();
  console.log("-------------------", this.data);
  if (userAgent.match(/Alipay/i) == "alipay") {
    //alert("支付宝浏览器");

    return "alipay";
  } else if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
    // alert("微信浏览器");

    return "wechat";
  } else {
    return "h5";
  }
}; */
export const a = function () { };

export const imgToBase64 = async function (url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth; // 使用 naturalWidth 为了保证图片的清晰度
      canvas.height = image.naturalHeight;
      canvas.style.width = `${canvas.width / window.devicePixelRatio}px`;
      canvas.style.height = `${canvas.height / window.devicePixelRatio}px`;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return null;
      }
      ctx.drawImage(image, 0, 0);
      const base64 = canvas.toDataURL("image/png");
      return resolve(base64);
    };
    image.onerror = err => {
      return reject(err);
    };
  });
};

/* export const pxtoMM = function(count, key = "mm") {
  // 像素 = 毫米 * (像素密度 / 25.4)
  const inch = document.createElement("div");
  inch.style.width = "1in";
  // 将div的尺寸设置为1英寸后，它会自动根据设备的分辨率进行缩放
  document.body.appendChild(inch);
  const dpi = inch.offsetWidth;
  document.body.removeChild(inch);
  const unit = Number(count);
  const inchs = unit / 25.4; // 将毫米转换为英寸,cm就除与2.54以此类推
  const px = inchs * dpi; // 将英寸转换为像素
  return Math.round(px); // 四舍五入取整数像素值

  switch (key) {
    case "mm":
      const px = (count * dpi) / 25.4;
      return Math.round(px);
    case "px":
      const mm = count / inchs;
      return Math.round(mm);
  }
}; */

/**
 * 获取经纬度
 *
 */
export const getJingWei = function () {
  if (navigator.geolocation) {
    console.log(navigator.geolocation.getCurrentPosition);
    navigator.geolocation.getCurrentPosition(
      //locationSuccess 获取成功的话
      /* eslint-disable */
      function (position) {
        console.log("经纬度", position);
        _this.getLongitude = position.coords.longitude;
        _this.getLatitude = position.coords.latitude;
        alert(_this.getLongitude); //弹出经度测试
        alert(_this.getLatitude);
      },
      //locationError  获取失败的话
      function (error) {
        var errorType = [
          "您拒绝共享位置信息",
          "获取不到位置信息",
          "获取位置信息超时"
        ];
        alert(errorType[error.code - 1]);
      }
    );
  }
};

/**
 * 获取经纬度
 */
export const getLongitudeLatitude = function () {
  //如果该对象存在，那么地理位置服务可用。
  if ("geolocation" in navigator) {
    /* 地理位置服务可用 */
    /* eslint-disable */
    var options = {
      enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
      timeout: 10000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
      maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
    };
    console.log("定位", navigator);
    function success(position) {
      //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
      //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
      var lat = position.coords.latitude; //当前位置的纬度
      var lng = position.coords.longitude; //当前位置精度
    }
    function error(err) {
      var errorType = [
        "您拒绝共享位置信息",
        "获取不到位置信息",
        "获取位置信息超时"
      ];
      console.log(errorType[err.code - 1]);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  } else {
    /* 地理位置服务不可用 */
    console.log("无法获取您的位置，请检查定位是否开启或刷新重试");
  }
};

/**
 * 将对象的空值删除
 * @param {object} obj 需要判断的对象
 * @returns
 */
export const removeEmptyValues = function (obj) {
  /* console.log("obj==============================", obj);
  let aobj = {}; */
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "" && !(typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}

/**
 * 显示确认对话框
 * @param {string} [title="提示"] - 对话框标题
 * @param {string} [detail="确定继续此操作吗？"] - 对话框内容/消息
 * @param {string} [confirm="确定"] - 确认按钮文本
 * @param {string} [cancel="取消"] - 取消按钮文本
 * @returns {Promise<boolean>} 返回一个 Promise，用户点击确认时解析为 true，取消时解析为 false
 */
export const showDialog = function (title = "提示", detail = "确定继续此操作吗？", confirm = "确定", cancel = "取消") {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(detail, title, {
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      showCancelButton: true,
      type: 'warning'
    }).then(() => {
      resolve(true);
    }).catch(() => {
      Message.warning("取消操作");
      resolve(false)
    });
  })
}

/**
 * 对象排序
 * @param {*} jsonData 需要排序的对象
 * @returns 
 */
export const sortJSONByKeys = function (jsonData) {
  const sortedKeys = Object.keys(jsonData).sort((a, b) => {
    // 按数字比较（你的键都是数字字符串）
    return parseInt(a) - parseInt(b);
  });

  const result = {};
  sortedKeys.forEach(key => {
    result[key] = jsonData[key];
  });

  return result;
}

/**
 * 判断传入的数据是否是json
 * @param {any} e 需要判断的数据
 */
export const checkJson = function(e) {
	try {
		return JSON.parse(e);
	} catch (err) {
		// console.log("Object.prototype.toString.call(e)", Object.prototype.toString.call(e));
		if (Object.prototype.toString.call(e) === '[object Object]') {
			return e;
		} else {
			return false;
		}
	}
}